import Vue from 'vue'

import { addCustomWidgetSchema } from '@/components/form-designer/widget-panel/widgetsConfig'
// 注册属性设置组件
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
// 生成组件属性设置
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import picker from "@/extension/h5/picker"

addCustomWidgetSchema({
  type: 'picker',
  icon: 'alert',
  formItemFlag: true,
  options: {
    name: '',
    label: 'picker选择器',
    title: '职业',
    columnWidth: '200px',
    defaultValue1: '',
    required: false,
    requiredHint: '',
    placeholder: '',
    textAlign: "left",//文字对齐方式
    disabled:false,
    labelWidth: '110',
    labelHidden: true,
    labelAlign: 'label-right-align',
    labelKey: 'dicValue',
    valueKey: 'dicKey',
    optionItems: [
      {
        "dicValue": "国家机关，党群组织，企业，事业单位负责人，公司职员",
        "dicKey": "0"
      },
      {
        "dicValue": "专业技术人员",
        "dicKey": "1"
      },
      {
        "dicValue": "办事人员和有关人员",
        "dicKey": "2"
      },
      {
        "dicValue": "商业，服务业人员",
        "dicKey": "3"
      },
      {
        "dicValue": "农，林，牧，渔，水利业生产人员",
        "dicKey": "4"
      },
      {
        "dicValue": "生产，运输设备操作人员及有关人员",
        "dicKey": "5"
      },
      {
        "dicValue": "军人",
        "dicKey": "6"
      },
      {
        "dicValue": "其他从业人员",
        "dicKey": "7"
      },
      {
        "dicValue": "文、教、体",
        "dicKey": "9"
      },
      {
        "dicValue": "工人",
        "dicKey": "10"
      },
      {
        "dicValue": "无业",
        "dicKey": "8"
      },
      {
        "dicValue": "个体",
        "dicKey": "11"
      },
      {
        "dicValue": "医护人员",
        "dicKey": "13"
      },
      {
        "dicValue": "警察",
        "dicKey": "14"
      },
      {
        "dicValue": "家务",
        "dicKey": "12"
      },
      {
        "dicValue": "IT，互联网从事者",
        "dicKey": "15"
      },
      {
        "dicValue": "司机",
        "dicKey": "16"
      }
    ],
    //-------------------
    customClass: '',  //自定义css类名
    //-------------------
    onCreated: '',
    onMounted: '',
    onChange: '',
  }
})  //加载组件Json Schema

Vue.component(picker.name, picker)  //注册组件

PERegister.registerCPEditor('defaultValue1', 'defaultValue1-editor',
  PEFactory.createInputTextEditor('defaultValue1', '默认值'))
PERegister.registerCPEditor('labelKeyName', 'labelKeyName-editor',
  PEFactory.createInputTextEditor('labelKeyName', '选项标签名'))
PERegister.registerCPEditor('valueKeyName', 'valueKeyName-editor',
  PEFactory.createInputTextEditor('valueKeyName', '选项值名'))


